(function($){
$(document).ready(function() {

    $('.slider-diapos-home').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 750,
        fade: true,
        cssEase: 'ease-out',
    });

    $('.slider-zoom').slick({
        // autoplay: true,
        // autoplaySpeed: 5000,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        fade: false,
        cssEase: 'ease-out',
    });

    $('.slider-actus').slick({
        // autoplay: true,
        // autoplaySpeed: 5000,
        arrows: true,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        fade: false,
        cssEase: 'ease-out',
    });

}); // document.ready
})(jQuery);
